import React, { useId } from 'react';
import { cn } from '@/lib/utils';

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    id?: string;
    className?: string;
    label?: string;
    description?: string;
    disabled?: boolean;
    'aria-label'?: string;
}

const Switch: React.FC<SwitchProps> = ({
    checked,
    onChange,
    id: idProp,
    className = '',
    label,
    description,
    disabled,
    'aria-label': ariaLabel,
}) => {
    const generatedId = useId();
    const switchId = idProp ?? generatedId;

    return (
        <label
            htmlFor={switchId}
            className={cn('toggle-wrap', disabled && 'cursor-not-allowed opacity-50', className)}
        >
            <input
                type="checkbox"
                id={switchId}
                name={switchId}
                className="sr-only"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
                aria-label={ariaLabel ?? label}
            />
            <div className={cn('toggle', checked && 'on')} aria-hidden="true">
                <div className="toggle-thumb" />
            </div>
            {(label || description) && (
                <div>
                    {label && <div className="toggle-label">{label}</div>}
                    {description && <div className="toggle-sub">{description}</div>}
                </div>
            )}
        </label>
    );
};

export default Switch;
